import ObservabilityPlugin from '@alice-health/observability'
import pkg from './../../package.json'

const options = {
  service: pkg.name,
  env: import.meta.env.VITE_ENV,
  clientToken: 'pubd6160314066a6234e05496bc06376498',
  applicationId: '36e465a3-b340-463d-84d6-413565ef1320',
  customOptions: {
    version: pkg.version
  }
}

const plugin = ObservabilityPlugin(options)

plugin?.initLogs()
plugin?.startSessionReplayRecording()
